import React from "react";
import {
  Box,
  CardMedia,
  Container,
  makeStyles,
  Typography,
} from "@material-ui/core";
import photo1 from "../../../assets/aboutUs/about1_1.png";
import photo2 from "../../../assets/aboutUs/about1_2.png";

const useStyles = makeStyles(({ breakpoints, spacing, palette }) => ({
  container: {
    display: "grid",
    gridTemplateRows: "40% 60%",
    overflow: "hidden",
  },
  text: {
    display: "grid",
    gridTemplateRows: "175px 85px",
    gridTemplateColumns: "40%",
    marginLeft: "6%",
  },
  title: {
    fontWeight: "bold",
    fontSize: "64px",
    lineHeight: "100%",
    color: "	#404040",
    textShadow: " 4px 4px 30px rgba(150, 150, 150, 0.53)",
  },
  paragraph: {
    fontWeight: 300,
    fontSize: "18px",
    lineHeight: "23px",
  },
  images: {
    display: "grid",
    gridTemplateColumns: "60% 30%",
    gridTemplateRows: "100%",
    gap: spacing(3),
    marginLeft: "auto",
  },
  img: {
    height: "100%",
    width: "100%",
  },
}));

const about1 = () => {
  const classes = useStyles();

  return (
    <Box component="div" className={classes.container}>
      <Container className={classes.text}>
        <Typography variant="h5" className={classes.title}>
          Somos Iluminarte S.A
        </Typography>
        <Typography p="true" className={classes.paragraph}>
          Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
          sint. Velit officia consequat duis enim velit mollit. Exercitation
          veniam consequat sunt nostrud amet.
        </Typography>
      </Container>
      <Box component="div" className={classes.images}>
        <CardMedia className={classes.img} component="img" image={photo1} />
        <CardMedia className={classes.img} component="img" image={photo2} />
      </Box>
    </Box>
  );
};

export default about1;
